import { motion } from "framer-motion";
import { SectionHeader } from "@/components/Reveal";
import { GALLERY_ITEMS } from "@/lib/site";

export default function Gallery() {
    return (
        <section
            id="galeria"
            data-testid="gallery-section"
            className="py-20 sm:py-28 lg:py-32 bg-charcoal relative"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
                <SectionHeader
                    eyebrow="Galeria"
                    title="Dentro do Ritual"
                    subtitle="Um ambiente pensado em cada detalhe — da cadeira clássica ao acabamento final."
                />

                <div className="mt-14 grid grid-cols-1 md:grid-cols-12 md:auto-rows-[190px] gap-4 sm:gap-5">
                    {GALLERY_ITEMS.map((g, i) => (
                        <motion.figure
                            key={g.label}
                            data-testid="gallery-grid-item"
                            initial={{ opacity: 0, y: 32 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.15 }}
                            transition={{
                                duration: 0.7,
                                ease: [0.22, 1, 0.36, 1],
                                delay: (i % 3) * 0.1,
                            }}
                            className={`group relative overflow-hidden rounded-2xl border border-white/8 hover:border-gold/40 transition-colors duration-500 h-64 md:h-auto ${g.span}`}
                        >
                            <img
                                src={g.src}
                                alt={g.label}
                                loading="lazy"
                                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-obsidian/85 via-transparent to-transparent opacity-70 group-hover:opacity-95 transition-opacity duration-500" />
                            <figcaption className="absolute bottom-0 left-0 right-0 p-5 flex items-center justify-between translate-y-2 opacity-90 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                                <span className="text-sm uppercase tracking-[0.2em] text-cream font-medium">
                                    {g.label}
                                </span>
                                <span className="h-px w-8 bg-gold" />
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
